export const unlock = () => (
  <path
    d="M7 11V7a5 5 0 019.9-1M5 11h14a2 2 0 012 2v7a2 2 0 01-2 2H5a2 2 0 01-2-2v-7a2 2 0 012-2z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
